import { RmaEntityTypeCodes } from '@harvestiq/constants';

export function isIndividualEntity({ type }: { type?: string | null }) {
  if (!type) {
    return false;
  }

  const isIndividualType = type === RmaEntityTypeCodes.Individuals;
  const isSpousalType = type === RmaEntityTypeCodes.SpousalMarried;
  return isIndividualType || isSpousalType;
}
